module.exports = __webpack_public_path__ + "img/icon-2.2eeeac21.png";